import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
Vue.use(ElementUI);
// 注册组件后即可使用
import router from './router'

import VDistpicker from 'v-distpicker'

Vue.component('v-distpicker', VDistpicker)
import store from './store'
import axios from 'axios'
Vue.prototype.$axios = axios;
axios.defaults.baseURL = 'http://106.13.89.24:8999'; //正式：http://49.235.92.52:8999
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
